import { ISolitaire } from '../Models/solitaire'

export class SolitaireMove<T extends ISolitaire> {
    isTrivial() : boolean
    {
        return false;
    }
}